/**
 * This file is part of the Colibrio Reader SDK and is governed by the terms and conditions stated in the
 * LICENSE_SAMPLE_CODE.md file.
 *
 * @copyright Share My World AB - All Rights Reserved
 */

export default class HttpRequest {

    static sendRangeRequest(url, start, end) {
        return new Promise((resolve, reject) => {
            const request = HttpRequest.createRequest("GET", url, reject);

            request.setRequestHeader("Range", `bytes=${start}-${end}`);
            request.onload = function(_event) {
                resolve(this.response);
            };
            request.send();
        });
    }
   static createRequest(verb, url, rejectFn) {
        const request = new XMLHttpRequest();
        request.open(verb, url , true);
        request.setRequestHeader("Content-Type", "application/epub+zip");
        request.setRequestHeader("Access-Control-Expose-Headers", "Content-Length");
        request.setRequestHeader("Access-Control-Allow-Origin" , "*");
        request.setRequestHeader("Access-Control-Allow-Methods", "GET, POST, PUT");
        request.setRequestHeader("Access-Control-Allow-Headers", "Content-Type, Content-Length");
        request.setRequestHeader("Access-Control-Allow-Credentials","true");

        request.responseType = "arraybuffer";

        request.onerror = function(_event) {
            rejectFn(this.status + ": " + this.statusText);
        };

        request.onabort = function(_event) {
            rejectFn(this.status + ": " + this.statusText);
        };

        request.ontimeout = function(_event) {
            rejectFn("TIMEOUT");
        };

        return request;
    }
}
